import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const COOKIE_KEY = "zwahili_cookie_consent";

// Custom event name to re-show the banner
const SHOW_COOKIE_EVENT = "zwahili:show-cookie-banner";

export const showCookieBanner = () => {
  window.dispatchEvent(new CustomEvent(SHOW_COOKIE_EVENT));
};

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  const show = useCallback(() => setVisible(true), []);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(show, 1500);
      return () => clearTimeout(timer);
    }
  }, [show]);

  useEffect(() => {
    window.addEventListener(SHOW_COOKIE_EVENT, show);
    return () => window.removeEventListener(SHOW_COOKIE_EVENT, show);
  }, [show]);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem(COOKIE_KEY, "dismissed");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-16 left-0 right-0 z-50 px-3 pb-3 animate-in slide-in-from-bottom-4 duration-500">
      <div className="max-w-md mx-auto bg-card border border-border rounded-md shadow-lg p-3 flex items-center gap-3">
        <p className="text-xs text-muted-foreground leading-snug flex-1">
          We use cookies to enhance your experience. See our{" "}
          <Link to="/privacy" className="text-primary hover:text-gold-light underline underline-offset-2 transition-colors">
            Privacy Policy
          </Link>
          .
        </p>
        <div className="flex items-center gap-1 shrink-0">
          <button
            onClick={accept}
            className="px-3 py-1.5 text-xs font-medium bg-primary text-primary-foreground rounded hover:bg-accent transition-colors"
          >
            Accept
          </button>
          <button
            onClick={dismiss}
            aria-label="Dismiss"
            className="p-1.5 text-muted-foreground hover:text-foreground transition-colors"
          >
            <X size={14} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
